import { useEffect, useState } from "react";
// Redux
import { useDispatch, useSelector } from "react-redux";
import { ConfigurationPanel } from "../..";
import "./style.css";
import { BsTv } from "react-icons/bs";
import { SmallCard } from "../../../../../../components/smallCard";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { Button, Select, translateMessage } from "@delibrandev/utils";
import { Input } from "@delibrandev/utils";
import { GoPlus } from "react-icons/go";
import { getSalesChannels } from "../../../../../../api/salesChannels";
import { getCategories } from "../../../../../../api/categories";
import { deleteOrderManager, editOrderManager, getOrderManagers, getUsers, newOrderManager } from "../../../../../../api/configuration";
import { addIdKeyIfMissing } from "@delibrandev/utils/src/function.js";
import { Datatable } from "@delibrandev/utils";
import { setAlert, updateDatatableCheckColumn, updateDatatableSelectedRows } from "../../../../../../reducers/userConfigSlice";

export const PointInvoice = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [users, setUsers] = useState([]);
  const [salesChannels, setSalesChannels] = useState([]);
  const [categories, setCategories] = useState([]);
  const [optionSelected, setOptionSelected] = useState(null);

  const handleOption = (data) => {
    setOptionSelected(data);

    const selectedRowsChannels = data && data.SalesChannels ? data.SalesChannels.map((channel) => channel.salesChannelId) : [];
    dispatch(updateDatatableSelectedRows({ selectedRows: selectedRowsChannels, table: "config-kd-channels" }));

    const selectedRowsCategories = data && data.Categories ? data.Categories.map((category) => category.categoryId) : [];
    dispatch(updateDatatableSelectedRows({ selectedRows: selectedRowsCategories, table: "config-kd-categories" }));
  };

  const getQuery = async () => {
    try {
      const payload = {};
      const response = await getOrderManagers(payload);
      if (response && !response.error) {
        setData(response.data);
      }
    } catch (error) {
      console.error("Error en la petición:", error);
    }

    try {
      const payload = {};
      const response = await getUsers(payload);
      if (response && !response.error) {
        setUsers(response.data);
      }
    } catch (error) {
      console.error("Error en la petición:", error);
    }

    try {
      const payload = {};
      const response = await getSalesChannels(payload);
      if (response && !response.error) {
        setSalesChannels(response.data);
      }
    } catch (error) {
      console.error("Error en la petición:", error);
    }

    try {
      const payload = {};
      const response = await getCategories(payload);
      if (response && !response.error) {
        setCategories(response.data);
      }
    } catch (error) {
      console.error("Error en la petición:", error);
    }
  };

  const deleteQuery = async (OrderManagerConfigurationId) => {
    console.log(OrderManagerConfigurationId);
    try {
      //const payload = {};
      const response = await deleteOrderManager(OrderManagerConfigurationId);
      if (response && !response.error) {
        dispatch(setAlert(translateMessage(response?.message || "Bad request")));
        getQuery();
      }
    } catch (error) {
      console.error("Error en la petición:", error);
    }
  };

  useEffect(() => {
    getQuery();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const Component = () => {
    return (
      <>
        <div className="cardsContainer">
          {data?.map((option) => (
            <SmallCard
              key={option.orderManagerConfigurationId || option.name}
              icon={<BsTv />}
              name={`${option.name} ${option.name === "Gestor de pedidos por defecto" ? " para la tienda online" : ""}`}
              options={
                option.name !== "Gestor de pedidos por defecto" && [
                  { icon: <FiEdit2 />, callback: () => handleOption(option) },
                  { icon: <FiTrash2 />, callback: () => deleteQuery(option.orderManagerConfigurationId) },
                ]
              }
            />
          ))}
          <SmallCard
            className="newCard"
            icon={<BsTv />}
            name={"Nuevo"}
            options={[{ icon: <GoPlus size={"1rem"} />, callback: () => handleOption({ OrderManagerConfigurationId: null, name: "Nuevo gestor" }) }]}
          />
        </div>
      </>
    );
  };

  const ComponentSelected = ({ data }) => {
    const selectedRowsChannels =
      useSelector((state) => state.aplicationConfig.userConfig?.datatable?.tables["config-kd-channels"]?.selectedRows) || [];
    const selectedRowsCategories =
      useSelector((state) => state.aplicationConfig.userConfig?.datatable?.tables["config-kd-categories"]?.selectedRows) || [];

    // Estado local seguro (fallback a [])
    const [assignedUsers, updateAssignedUsers] = useState(data?.assignedUsers ?? []);

    // Sincroniza si cambian los datos de entrada
    useEffect(() => {
      updateAssignedUsers(data?.assignedUsers ?? []);
    }, [data?.assignedUsers]);

    const update = async () => {
      try {
        const payload = {
          name: document.getElementById("name").value,
          userIds: (assignedUsers ?? []).map((u) => u.userId), // ← usamos estado, no querySelectorAll
          deliveryTime: parseInt(document.getElementById("deliveryTime").value),
          preparationTime: parseInt(document.getElementById("preparationTime").value),
          salesChannelsIds: selectedRowsChannels,
          categoryIds: selectedRowsCategories,
        };
        console.log(payload);

        if (data.orderManagerConfigurationId) {
          const response = await editOrderManager(data.orderManagerConfigurationId, payload);
          if (response && !response.error) {
            handleOption(null);
            getQuery();
            dispatch(setAlert(translateMessage(response?.message || "Bad request")));
          }
        } else {
          const response = await newOrderManager(payload);
          if (response && !response.error) {
            handleOption(null);
            getQuery();
            dispatch(setAlert(translateMessage(response?.message || "Bad request")));
          }
        }
      } catch (error) {
        console.error("Error en la petición:", error);
      }
    };

    // Toggle de usuarios asignados
    const handleCheckboxChange = (userId) => {
      updateAssignedUsers((prev) => {
        const current = Array.isArray(prev) ? prev : [];
        const exists = current.some((u) => u.userId === userId);
        if (exists) {
          return current.filter((u) => u.userId !== userId);
        }
        return [...current, { userId }];
      });
    };

    const DatatableChannels = () => {
      const identificator = "config-kd-channels";
      const checkColumn = useSelector((state) => state.aplicationConfig.userConfig.datatable.tables[identificator]?.checkColumn);
      const checkedRows = useSelector((state) => state.aplicationConfig.userConfig.datatable.tables[identificator]?.selectedRows);
      const handleCheckColumn = () => {
        dispatch(updateDatatableCheckColumn({ table: identificator }));
      };

      const handleSelectedRows = (updatedSelectedRows = null) => {
        dispatch(updateDatatableSelectedRows({ selectedRows: updatedSelectedRows, table: identificator }));
      };

      useEffect(() => {
        dispatch(updateDatatableCheckColumn({ checkColumn: true, table: identificator }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);

      return (
        <>
          <div className="row mt-3 mb-3 ">
            <div className="col-8">
              <div className="inputLabel">Canales</div>
              <div className="inputDescription">Seleccione los canales que desea visualizar</div>
            </div>
            <div className="col-4 flex-end"></div>
          </div>

          <Datatable
            identificator={identificator}
            title={""}
            subtitle={""}
            data={addIdKeyIfMissing(salesChannels, "salesChannelId")}
            addCallback={() => null}
            checkColumn={checkColumn}
            checkedRows={checkedRows}
            handleCheckColumn={handleCheckColumn}
            handleSelectedRows={handleSelectedRows}
          />
        </>
      );
    };

    const DatatableCategories = () => {
      const identificator = "config-kd-categories";
      const checkColumn = useSelector((state) => state.aplicationConfig.userConfig.datatable.tables[identificator]?.checkColumn);
      const checkedRows = useSelector((state) => state.aplicationConfig.userConfig.datatable.tables[identificator]?.selectedRows);
      const handleCheckColumn = () => {
        dispatch(updateDatatableCheckColumn({ table: identificator }));
      };

      const handleSelectedRows = (updatedSelectedRows = null) => {
        dispatch(updateDatatableSelectedRows({ selectedRows: updatedSelectedRows, table: identificator }));
      };

      useEffect(() => {
        dispatch(updateDatatableCheckColumn({ checkColumn: true, table: identificator }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);

      return (
        <>
          <div className="row mt-3 mb-3 ">
            <div className="col-8">
              <div className="inputLabel">Categorías</div>
              <div className="inputDescription">Seleccione las categorías que no desea mostrar</div>
            </div>
            <div className="col-4 flex-end"></div>
          </div>

          <Datatable
            identificator={identificator}
            title={""}
            subtitle={""}
            data={addIdKeyIfMissing(categories, "categoryId")}
            addCallback={() => null}
            checkColumn={checkColumn}
            checkedRows={checkedRows}
            handleCheckColumn={handleCheckColumn}
            handleSelectedRows={handleSelectedRows}
          />
        </>
      );
    };

    return (
      <>
        <div className="row" style={{ marginTop: "-30px", marginBottom: "25px" }}>
          <div className="col-8"></div>
          <div className="col-4 flex-end">
            <Button
              text={data.orderManagerConfigurationId ? "Actualizar" : "Guardar"}
              icon={null}
              customClass={"customButtonColor2"}
              action={update}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <Input
              id={"name"}
              type={"text"}
              placeholder=""
              icon={null}
              classname={"w-100"}
              iconPositionRight={true}
              label="Nombre"
              description=""
              defaultValue={data?.name || ""}
            />
          </div>
          <div className="col-6">
            <div className="row">
              <div className="col-12">
                <Select
                  id={"preparationTime"}
                  value={data?.preparationTime || ""}
                  values={[
                    { id: 10, name: "10 minutos" },
                    { id: 20, name: "20 minutos" },
                    { id: 30, name: "30 minutos" },
                  ]}
                  callback={() => null}
                  label="Tiempo estimado de preparación"
                  description=""
                  classname={""}
                />
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-12">
                <Select
                  id={"deliveryTime"}
                  value={data?.deliveryTime || ""}
                  values={[
                    { id: 10, name: "10 minutos" },
                    { id: 20, name: "20 minutos" },
                    { id: 30, name: "30 minutos" },
                  ]}
                  callback={() => null}
                  label="Tiempo estimado de entrega"
                  description=""
                  classname={""}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="inputLabel mt-4 mb-2">Usuarios activos</div>
        <div className="flex-start gap-2 flex-wrap">
          {users.owners?.map(
            (user) =>
              user.role !== "admin" && (
                <div key={user.userId}>
                  <input
                    id={"activeUser-" + user.userId}
                    type="checkbox"
                    className="custom-checkbox activeUsers"
                    value={user.userId}
                    checked={(assignedUsers ?? []).some((u) => u.userId === user.userId)}
                    onChange={() => handleCheckboxChange(user.userId)}
                  />
                  {" " + user.fullname}
                </div>
              )
          )}
          {users.corpUsers?.map((user) => (
            <div key={user.userId}>
              <input
                id={"activeUser-" + user.userId}
                type="checkbox"
                className="custom-checkbox activeUsers"
                value={user.userId}
                checked={(assignedUsers ?? []).some((u) => u.userId === user.userId)}
                onChange={() => handleCheckboxChange(user.userId)}
              />
              {" " + user.fullname}
            </div>
          ))}
        </div>

        <div className="row mt-4 mb-2">
          <DatatableChannels />
        </div>

        <div className="row mt-4 mb-2">
          <DatatableCategories />
        </div>
      </>
    );
  };

  return (
    <>
      <ConfigurationPanel title="Gestor de pedidos" content={<Component />} hasButtonSave={false} />
      {optionSelected !== null && (
        <ConfigurationPanel
          title={"Configuración de " + optionSelected.name}
          content={<ComponentSelected data={optionSelected} />}
          hasButtonSave={false}
        />
      )}
    </>
  );
};
